// Default state
export const DEFAULT_STATE = {
  isFetching: true,
  isError: false,
  response: {}
};
export const DEFAULT_STATE_FF_EF = {
  isFetching: false,
  isError: false,
  response: {}
};
export const DEFAULT_STATE_FF_ET = {
  isFetching: false,
  isError: true,
  response: {}
};

// redux state to toggle menu items
export const sidebarToggleItems = {
  users: false,
  bookings: false,
  operatorTrips: false,
  drivers: false,
  customers: false,
  taxidaUsers: false,
  invoice: false,
  fare: false,
  operators: false
};

export const weekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];

export const priceTypes = {
  1: "Flat",
  2: "Percentage"
};
export const paymentPercentage = [
  { label: "Full", value: 100 },
  { label: "10%", value: 10 },
  { label: "Cash", value: 0 },
  { label: "Account", value: "account" }
];
export const advancePercentage = 10;

export const bookingType = {
  bookRide: "One way",
  round: "Round trip",
  multiCity: "Multi-city",
  package: "Package"
};
export const bookingTypeFilter = {
  oneWay: "One way",
  roundTrip: "Round trip",
  multiCity: "Multicity",
  package: "Package"
};
export const multicityDuration = [
  { label: "00:30", value: 30 },
  { label: "01:00", value: 60 },
  { label: "01:30", value: 90 },
  { label: "02:00", value: 120 },
  { label: "02:30", value: 150 },
  { label: "03:00", value: 180 },
  { label: "03:30", value: 210 },
  { label: "04:00", value: 240 },
  { label: "04:30", value: 270 },
  { label: "05:00", value: 300 },
  { label: "05:30", value: 330 },
  { label: "06:00", value: 360 }
];
// export const packageDuration = [
//   { label: "4 hrs", value: 240 },
//   { label: "8 hrs", value: 480 },
//   { label: "12 hrs", value: 720 },
//   { label: "16 hrs", value: 960 },
//   { label: "20 hrs", value: 1200 },
//   { label: "1 days", value: 1440 },
//   { label: "2 days", value: 2880 },
//   { label: "3 days", value: 4320 },
//   { label: "4 days", value: 5760 },
//   { label: "5 days", value: 7200 },
//   { label: "10 days", value: 14400 },
//   { label: "15 days", value: 21600 },
//   { label: "30 days", value: 43200 }
// ];
export const subscriptionTypes = {
  subscription: "Subscription",
  perRide: "Per ride"
};
export const bidExpiryType = {
  fromNow: "From now",
  beforePickup: "Before pickup time"
};

export const TIME_FORMAT_TO_SHOW = "HH:mm A";
export const DATE_FORMAT_TO_SHOW = "DD-MM-YYYY";
export const OTP_RESEND_INTERVAL = 45; //time in seconds

export const subscriptionPriceTypes = {
  subscription: {
    bucket: "Bucket",
    flat: "Flat"
  },
  perRide: {
    flat: "Flat",
    percentage: "Percentage"
  }
};
export const rideTypes = {
  pickup: "Pickup",
  dropoff: "Drop",
  both: "Pickup and Drop",
  any: "Pickup or Drop"
};

export const operatingRideTypes = {
  pickup: "Pickup",
  dropoff: "Drop",
  both: "Pickup and Drop",
  any: "Pickup or Drop"
};

export const operatingTripTypes = {
  outstation: "Outstation",
  local: "Local"
};

export const bookingStatus = {
  1: "Pending",
  // 2: "Accepted", // there is no accepted status for now
  3: "Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Arrived",
  8: "On Trip",
  9: "Cancelled",
  10: "Completed",
  11: "On Bid"
};

export const b2bBookingStatus = {
  1: "Pending",
  2: "Operator Assigned",
  3: "Driver Assigned",
  4: "Driver Accepted",
  5: "Driver Rejected",
  6: "En Route To Pickup",
  7: "Driver Arrived",
  8: "On Trip-Empty",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled",
  12: "Pending for approval",
  14: "Fare Requested",
  15: "Taxida verified",
  16: "Invoiced"
};

export const tripTypeStatus = {
  1: "One way",
  2: "Round trip",
  3: "Multicity",
  4: "Package"
};

export const operatorBookingStatus = {
  1: "Pending",
  2: "On Bid",
  3: "Responded",
  4: "Assigned"
};

export const bgColors = {
  1: "bg-lred",
  2: "bg-yellow",
  3: "bg-grn",
  4: "bg-grey",
  5: "bg-dred",
  6: "bg-blu",
  7: "bg-yellow",
  8: "bg-lgrn",
  9: "bg-lgrey",
  10: "bg-sail",
  11: "bg-grey",
  12: "bg-lgrey",
  14: "bg-dred",
  15: "bg-sail",
  16: "bg-sail"
};
// user Roles and its labels
export const userRoles = {
  1: "admin",
  2: "subAdmin",
  3: "controller",
  4: "affiliateAgent",
  5: "aggregator",
  6: "businessUser",
  7: "driver",
  8: "customer",
  9: "driverManager"
};
export const userRoleLabels = {
  1: "Admin",
  2: "Sub-admin",
  3: "Controller",
  4: "Affiliate agent",
  5: "Aggregator",
  6: "Business User",
  7: "Driver",
  8: "Customer",
  9: "Driver manager"
};
export const tripType = [
  {
    label: "Book ride",
    value: "bookRide"
  },
  {
    label: "Multi-city",
    value: "multiCity"
  },
  { label: "Package", value: "package" }
];
export const trip = {
  oneway: "One way",
  round: "Round",
  both: "Both"
};

export const recordStatus = {
  paid: "Paid",
  unpaid: "Unpaid",
  partiallyPaid: "Partial"
};

export const rolePermissions = [
  {
    user: "Admin",
    roleId: 1,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "delete", "assign", "broadcast"],
      users: ["create", "edit", "delete"],
      drivers: ["create", "edit", "delete"],
      driverGroup: ["create", "edit", "delete"],
      operators: ["create", "edit", "delete"],
      operatorGroup: ["create", "edit", "delete"],
      fare: ["create", "edit", "delete"],
      commissions: ["create", "edit", "delete"],
      vehicleTypes: ["create", "edit", "delete"],
      taxidaQuotes: ["create", "edit", "delete"],
      statements: ["create", "edit"],
      invoice: ["create", "edit"],
      driverAlert: ["edit", "delete"],
      promoCodes: ["create", "edit", "delete"],
      operatingArea: ["create", "edit", "delete"]
    }
  },
  {
    user: "Sub-admin",
    roleId: 2,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "assign", "broadcast"],
      users: ["create"],
      drivers: ["create"],
      driverGroup: ["create"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  },
  {
    user: "Controller",
    roleId: 3,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit", "assign", "broadcast"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  },
  {
    user: "Affiliate agent",
    roleId: 4,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  },
  {
    user: "Business-User",
    roleId: 6,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  },
  {
    user: "Affiliate-driver",
    roleId: 7,
    permissions: {
      dashboard: [],
      bookings: ["create", "edit"],
      users: [],
      drivers: [],
      driverGroup: [],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  },
  {
    user: "Driver manager",
    roleId: 9,
    permissions: {
      dashboard: [],
      bookings: [],
      users: [],
      drivers: ["create", "edit"],
      driverGroup: ["create", "edit"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  },
  {
    user: "Operators",
    roleId: 10,
    permissions: {
      dashboard: [],
      bookings: [],
      users: [],
      drivers: ["create", "edit", "delete"],
      driverGroup: ["create", "edit", "delete"],
      operators: [],
      operatorGroup: [],
      fare: [],
      commissions: [],
      vehicleTypes: [],
      statements: [],
      invoice: [],
      driverAlert: [],
      promoCodes: [],
      operatingArea: [],
      taxidaQuotes: []
    }
  }
];

export const auctoBidDuration = [
  { label: "30mins", value: 30 },
  { label: "1hr", value: 60 },
  { label: "1hr 30mins", value: 90 },
  { label: "2hrs", value: 120 },
  { label: "2hrs 30mins", value: 150 },
  { label: "3hrs", value: 180 },
  { label: "3hrs 30mins", value: 210 },
  { label: "4hrs", value: 240 },
  { label: "4hrs 30mins", value: 270 },
  { label: "5hrs", value: 300 },
  { label: "5hrs 30mins", value: 330 },
  { label: "6hrs", value: 360 },
  { label: "6hrs 30mins", value: 390 },
  { label: "7hrs", value: 420 },
  { label: "7hrs 30mins", value: 450 },
  { label: "8hrs", value: 480 },
  { label: "8hrs 30mins", value: 510 },
  { label: "9hrs", value: 540 },
  { label: "9hrs 30mins", value: 570 },
  { label: "10hrs", value: 600 },
  { label: "10hrs 30mins", value: 630 },
  { label: "11hrs", value: 660 },
  { label: "11hrs 30mins", value: 690 },
  { label: "12hrs", value: 720 }
];

export const auctoConfigTime = [
  { label: "Bid expiry", value: "bidExpiry" },
  { label: "Min time", value: "minTime" }
];

export const stateList = [
  { value: "AN", label: "Andaman and Nicobar Islands" },
  { value: "AP", label: "Andhra Pradesh" },
  { value: "AR", label: "Arunachal Pradesh" },
  { value: "AS", label: "Assam" },
  { value: "BR", label: "Bihar" },
  { value: "CG", label: "Chandigarh" },
  { value: "CH", label: "Chhattisgarh" },
  { value: "DN", label: "Dadra and Nagar Haveli" },
  { value: "DD", label: "Daman and Diu" },
  { value: "DL", label: "Delhi" },
  { value: "GA", label: "Goa" },
  { value: "GJ", label: "Gujarat" },
  { value: "HR", label: "Haryana" },
  { value: "HP", label: "Himachal Pradesh" },
  { value: "JK", label: "Jammu and Kashmir" },
  { value: "JH", label: "Jharkhand" },
  { value: "KA", label: "Karnataka" },
  { value: "KL", label: "Kerala" },
  { value: "LA", label: "Ladakh" },
  { value: "LD", label: "Lakshadweep" },
  { value: "MP", label: "Madhya Pradesh" },
  { value: "MH", label: "Maharashtra" },
  { value: "MN", label: "Manipur" },
  { value: "ML", label: "Meghalaya" },
  { value: "MZ", label: "Mizoram" },
  { value: "NL", label: "Nagaland" },
  { value: "OR", label: "Odisha" },
  { value: "PY", label: "Puducherry" },
  { value: "PB", label: "Punjab" },
  { value: "RJ", label: "Rajasthan" },
  { value: "SK", label: "Sikkim" },
  { value: "TN", label: "Tamil Nadu" },
  { value: "TS", label: "Telangana" },
  { value: "TR", label: "Tripura" },
  { value: "UP", label: "Uttar Pradesh" },
  { value: "UK", label: "Uttarakhand" },
  { value: "WB", label: "West Bengal" }
];

export const hourNkm = [
  { label: "3hr-30Km", value: "3hr-30Km" },
  { label: "4hr-40km", value: "4hr-40km" },
  { label: "5hr-50km", value: "5hr-50km" },
  { label: "6hr-60km", value: "6hr-60km" },
  { label: "7hr-70km", value: "7hr-70km" },
  { label: "8hr-80km", value: "8hr-80km" },
  { label: "9hr-90km", value: "9hr-90km" },
  { label: "10hr-100km", value: "10hr-100km" },
  { label: "11hr-110km", value: "11hr-110km" },
  { label: "12hr-120km", value: "12hr-120km" }
];

export const minNoticePeriod = [
  { label: "00:15", value: 15 },
  { label: "00:30", value: 30 },
  { label: "00:45", value: 45 },
  { label: "01:00", value: 60 },
  { label: "01:30", value: 90 },
  { label: "02:00", value: 120 },
  { label: "02:30", value: 150 },
  { label: "03:00", value: 180 },
  { label: "04:00", value: 240 },
  { label: "05:00", value: 300 },
  { label: "06:00", value: 360 },
  { label: "07:00", value: 420 },
  { label: "08:00", value: 480 },
  { label: "09:00", value: 540 },
  { label: "10:00", value: 600 },
  { label: "11:00", value: 660 },
  { label: "12:00", value: 720 },
  { label: "13:00", value: 780 },
  { label: "14:00", value: 840 },
  { label: "15:00", value: 900 },
  { label: "16:00", value: 960 },
  { label: "17:00", value: 1020 },
  { label: "18:00", value: 1080 },
  { label: "19:00", value: 1140 },
  { label: "20:00", value: 1200 },
  { label: "21:00", value: 1260 },
  { label: "22:00", value: 1320 },
  { label: "23:00", value: 1380 },
  { label: "24:00", value: 1440 }
];
export const packageDuration = [
  { label: "2 hrs", value: 120 },
  { label: "3 hrs", value: 180 },
  { label: "4 hrs", value: 240 },
  { label: "5 hrs", value: 300 },
  { label: "6 hrs", value: 360 },
  { label: "7 hrs", value: 420 },
  { label: "8 hrs", value: 480 },
  { label: "9 hrs", value: 540 },
  { label: "10 hrs", value: 600 },
  { label: "11 hrs", value: 660 },
  { label: "12 hrs", value: 720 },
  { label: "1 days", value: 1440 },
  { label: "2 days", value: 2880 },
  { label: "3 days", value: 4320 },
  { label: "4 days", value: 5760 },
  { label: "5 days", value: 7200 },
  { label: "6 days", value: 8640 },
  { label: "7 days", value: 10800 },
  { label: "8 days", value: 11520 },
  { label: "9 days", value: 12960 },
  { label: "10 days", value: 14400 }
];

export const employeeType = [
  { label: "Employee", value: "employee" },
  { label: "Other", value: "other" }
];

export const etsVehicleType = [
  {
    label: "SUV",
    value: "SUV"
  },
  {
    label: "Sedan",
    value: "Sedan"
  }
];

export const etsBookingStatus = {
  1: "Queued",
  2: "Pending for Operator Assigned",
  3: "Operator Assigned",
  4: "Driver Assigned",
  5: "Driver Rejected",
  6: "Driver Accepted",
  7: "En Route To Pickup",
  8: "Driver Arrived",
  9: "On Trip",
  10: "Completed",
  11: "Cancelled"
};

export const etsTripType = {
  "Home pickup": "Home pickup",
  "Office pickup": "Office pickup"
};

export const etsEmployeeStatus = [
  {
    label: "To be onboard",
    value: "to be onboard"
  },
  {
    label: "On boarded",
    value: "onboarded"
  },
  {
    label: "Dropped",
    value: "dropped"
  },
  {
    label: "No-show",
    value: "no show"
  }
];
